export const colors = {
  correct: '#336611',
  error: '#661133',
  incorrect: '#212121',
  misplaced: '#996611',
};
